import React from 'react';
import { H2, P, UL, LI, FeatureLink } from './_shared';

export default {
  slug: 'broker-dashboard',
  title: 'Broker dashboard',
  category: 'team',
  summary: 'The brokerage-level view: compliance stats, top producers, at-risk agents, and the weekly AI briefing.',
  searchTerms: ['broker', 'dashboard', 'team', 'manager', 'agency', 'briefing'],
  related: ['team-workspace', 'compliance'],
  Body: () => (
    <>
      <P>
        <FeatureLink to="/broker">Broker Dashboard</FeatureLink> is the
        team-owner view of your brokerage. Hidden for solo accounts —
        appears automatically when your account has <code>team_id</code> set
        and you're the owner.
      </P>

      <H2>What's on it</H2>
      <UL>
        <LI><strong>Weekly AI briefing</strong> — a short, written summary of last week's pipeline, money in flight, and the three things to pay attention to this week. Refreshes every Monday at 6am local.</LI>
        <LI><strong>Compliance stats</strong> — % of folders with full checklist, count in <em>pending_review</em>, average days to broker approval.</LI>
        <LI><strong>Top 5 producers</strong> — by closed-deal volume YTD.</LI>
        <LI><strong>At-risk agents</strong> — agents whose pipeline health has dropped or whose response times have lengthened.</LI>
      </UL>

      <H2>Reading the at-risk list</H2>
      <P>
        Each at-risk agent shows a specific reason: "no folder activity in
        14 days," "median response time up 3x," "two folders past close
        date." Click through to their pipeline. This isn't a perf-review
        tool — it's a "who needs help" prompt.
      </P>

      <H2>Customizing</H2>
      <P>
        Brokerage admins can pin custom KPIs (commission tracking, source
        ROI, conversion by lead source) from Settings → Brokerage →
        Dashboard. Up to 6 pinned cards.
      </P>
    </>
  ),
};
